module.exports = __webpack_public_path__ + "static/media/login-logo.289c0513.png";